<div class='flex flex-col items-center justify-center modal-preview'>
    @if (mediaSelected(); as mSelected) {
        <div class='flex flex-row items-center justify-center item'>
            @if (mSelected.isLoading()) {
                <k-loading />
            }
            @else if (mSelected.isImage) {
                <img
                    [src]="mSelected.mediaUrl()"
                    alt="preview"
                />
            }
            @else if (mSelected.isVideo) {
                <k-video
                    class="max-w-[100vw] w-[740px]"
                    [src]="mSelected.url"
                    [options]="{ height: 420 }"
                />
            }
            @else if (mSelected.isAudio) {
                <div class='table'>
                    <audio controls>
                        <source [src]='mSelected.url' type='audio/mp3' />
                    </audio>
                </div>
            }
            @else if (mSelected.isRaw) {
                <div class='flex flex-col items-center justify-center file'>
                    <img style='min-height: 30%' class='mb-3'
                         src='../../../../../../../../assets/images/chat/scanner.svg' alt='Scanner file' />
                    {{ mSelected.file.name }}
                </div>
            }
        </div>
    }
    <div class='carousel'>
        @for (media of renderMedias(); track media.id;) {
            <div class='flex flex-row items-center justify-center options' [style.opacity.%]='media.opacity'>
                <div
                    class="cursor-pointer delete bg-kiwid-surface-sunken rounded-full flex-row items-center justify-center p-1.5"
                    (click)="media.actions.remove()"
                >
                    <mat-icon
                        svgIcon="kiwid:delete"
                        class="text-brand-main-dark size-18"
                    />
                </div>
                @if (media.isImage) {
                    @if (!!media.mediaUrl() && media.mediaUrl(); as url) {
                        <img
                            (click)="media.actions.click()"
                            [src]="url"
                            alt="preview"
                        />
                    }
                    @else {
                        <div
                            (click)="media.actions.click()"
                            class="file flex flex-col items-start justify-start"
                        >
                            <img
                                src="../../../../../../../../assets/images/chat/scanner.svg"
                                alt="Scanner file"
                            />
                            <span>{{ media.file.name }}</span>
                        </div>
                    }
                }
                @else if (media.isVideo) {
                    <k-video
                        [src]="media.url"
                        [options]="{ height: 100, width: 140, controls: false }"
                        (click)="media.actions.click()"
                    />
                }
                @else if (media.isRaw) {
                    <div
                        (click)="media.actions.click()"
                        class="file flex flex-col items-start justify-start"
                    >
                        <img
                            src="../../../../../../../../assets/images/chat/scanner.svg"
                            alt="Scanner file"
                        />
                        <span>{{ media.file.name }}</span>
                    </div>
                }
                @else if (media.isAudio) {
                    <img
                        (click)="media.actions.click()"
                        [src]="'/assets/images/media/audio-thumbnail.jpg'"
                        alt="image"
                        width="100px"
                        height="100px"
                    />
                }
            </div>
        }
        <div class='flex flex-row justify-center items-center min-w-[64px] h-[100px]'>
            <label for='add-file' class='w-[32px] h-[32px] rounded-full bg-brand-main-lightest flex flex-row justify-center items-center hover:cursor-pointer'>
                <mat-icon class='size-18 text-brand-main-darker'>add</mat-icon>
                <input #inputFile style='display: none' type='file' multiple id='add-file' (change)='addFile(inputFile)' />
            </label>
        </div>
    </div>
</div>
